import Helper from '../helpers/Helper';

export default class Map {
    constructor() {
        this.el = null;
        this.cookieName = 'gmap_optinout';
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;

        if (Helper.isInsideEditor()) {
            //let optin = document.querySelector('.contact__map-optin'),
            //    wrapper = document.querySelector('.module__map-iframe-wrapper');

            //this.createIframe(optin, wrapper);
            //return;
        }

        //this.initOptInOut();

        // remove map or/and change background image
        if (
            document
                .querySelector('.module-contact')
                .classList.contains('module-contact--layout-1') ||
            document
                .querySelector('.module-contact')
                .classList.contains('module-contact--layout-2') ||
            document
                .querySelector('.module-contact')
                .classList.contains('module-contact--layout-5') ||
            document.querySelector('.module-contact').classList.contains('module-contact--layout-6')
        ) {
            this.hideMapAndSetBackgroundImage();
        }

        if (
            document
                .querySelector('.module-contact')
                .classList.contains('module-contact--layout-3') ||
            document.querySelector('.module-contact').classList.contains('module-contact--layout-4')
        ) {
            this.removeMap();
        }
    }
    removeMap() {
        this.el.remove();
    }
    hideMapAndSetBackgroundImage() {
        let bgImage = '/files/media/images/contact/map.jpg';
        this.el.classList.add('contact__map-optin-bg');
        this.el.classList.remove('module__map-iframe-wrapper');
        this.el.style.backgroundImage = 'url(' + bgImage + ')';
    }
    setMapActive() {
        if ('ontouchstart' in window || navigator.msMaxTouchPoints) {
            this.el.querySelector('iframe').classList.add('module__map-iframe--active');
        } else {
            this.el.addEventListener('click', () => {
                this.el.querySelector('iframe').classList.add('module__map-iframe--active');
            });
            this.el.addEventListener('mouseleave', () => {
                this.el.querySelector('iframe').classList.remove('module__map-iframe--active');
            });
        }
    }
    initOptInOut() {
        let optin = document.querySelector('.contact__map-optin'),
            optinToggler = document.querySelector('.contact__map-optin-toggler'),
            optout = document.querySelector('.contact__map-optout'),
            optoutToggler = document.querySelector('.contact__map-optout-toggler'),
            wrapper = document.querySelector('.module__map-iframe-wrapper');

        if (this.getCookie()) {
            this.createIframe(optin, wrapper);
            optin.remove();
            optout.classList.add('contact__map-optout--active');
            optoutToggler.checked = true;
        }

        if (!this.getCookie()) {
            optin.classList.add('contact__map-optin--active');
            optinToggler.checked = false;
            optout.classList.remove('contact__map-optout--active');
            optoutToggler.checked = false;
        }

        optin.addEventListener('click', () => {
            this.createIframe(optin, wrapper);
            this.setCookie();
            optin.remove();
            optout.classList.add('contact__map-optout--active');
            optoutToggler.checked = true;
        });

        optout.addEventListener('click', () => {
            this.deleteCookie();
            location.reload();
        });
    }
    setCookie() {
        let expires = new Date();
        expires.setTime(expires.getTime() + 3 * 24 * 60 * 60 * 1000);
        document.cookie = this.cookieName + '=1;expires=' + expires.toUTCString() + ';path=/';
    }
    getCookie() {
        let keyValue = document.cookie.match('(^|;) ?' + this.cookieName + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }
    deleteCookie() {
        document.cookie = this.cookieName + '=1;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
    }
    createIframe(optin, wrapper) {
        let mapIframe = document.createElement('IFRAME');
        mapIframe.src = optin.dataset.source;
        mapIframe.className = optin.dataset.class;
        mapIframe.width = optin.dataset.width;
        mapIframe.height = optin.dataset.height;
        mapIframe.setAttribute('allowFullScreen', '');
        wrapper.appendChild(mapIframe);
        this.setMapActive();
    }
}
